import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { initTheme } from './theme/theme';

import AuthLayout from './layout/AuthLayout/AuthLayout';
import DashboardLayout from './layout/DashboardLayout/DashboardLayout';

import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import Home from './pages/Home';
import PrivateRoute from './routes/PrivateRoute';
import Billing from './pages/Billing';
import Playground from './pages/Playground';
import Settings from './pages/Settings';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';
import TenantList from './pages/Admin/TenantList';
import TenantDetail from './pages/Admin/TenantDetail';
import TenantEditor from './pages/Admin/TenantEditor';
import Plans from './pages/Plans';
import Profile from './pages/Profile';
import ApiKeys from './pages/ApiKeys';
import SearchPage from './pages/SearchPage';
import DashboardRedirect from './pages/DashboardRedirect';
import SchemaRegistry from './pages/SchemaRegistry';
import Checkout from './pages/Checkout';
import PendingApproval from './pages/PendingApproval';
import BookDemo from './pages/BookDemo';
import BillingActivate from './pages/BillingActivate';
import PolicyRegistry from './features/policies/pages/policyRegistry';
import LlmGateway from './pages/LlmGateway';
import ApiDocs from './pages/ApiDocs';
import GettingStarted from './pages/GettingStarted';
import AcceptInvite from './pages/AcceptInvite';


const App = () => {
  useEffect(() => {
    initTheme();
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/invite/accept" element={<AcceptInvite />} />
        <Route
          path="/forgot-password"
          element={
            <AuthLayout>
              <ForgotPassword />
            </AuthLayout>
          }
        />
        <Route path="/plans" element={<Plans />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/pending-approval" element={<PendingApproval />} />
        <Route path="/book-demo" element={<BookDemo />} />
        <Route path="/contact" element={<BookDemo />} />
        <Route path="/billing/activate" element={<BillingActivate />} />


        {/* Authenticated (All roles) */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <DashboardRedirect />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/getting-started"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <GettingStarted />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/setup-guide"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <GettingStarted />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/playground"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <Playground />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/gateway"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <LlmGateway />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/docs"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <ApiDocs />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/search"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <SearchPage />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <Profile />
              </DashboardLayout>
            </PrivateRoute>
          }
        />

        {/* Manager + Admin */}
        <Route
          path="/billing"
          element={
            <PrivateRoute managerOnly>
              <DashboardLayout>
                <Billing />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/apikeys"
          element={
            <PrivateRoute managerOnly>
              <DashboardLayout>
                <ApiKeys />
              </DashboardLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/schemas"
          element={
            <PrivateRoute managerOnly>
              <DashboardLayout>
                <SchemaRegistry />
              </DashboardLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/policies"
          element={
            <PrivateRoute managerOnly>
              <DashboardLayout>
                <PolicyRegistry />
              </DashboardLayout>
            </PrivateRoute>
          }
        />



        <Route
          path="/settings"
          element={
            <PrivateRoute managerOnly>
              <DashboardLayout>
                <Settings />
              </DashboardLayout>
            </PrivateRoute>
          }
        />

        {/* Admin only */}
        <Route
          path="/admin"
          element={
            <PrivateRoute adminOnly>
              <DashboardLayout>
                <Admin />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/tenants"
          element={
            <PrivateRoute adminOnly>
              <DashboardLayout>
                <TenantList />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/tenants/new"
          element={
            <PrivateRoute adminOnly>
              <DashboardLayout>
                <TenantEditor />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/tenants/:tenantId"
          element={
            <PrivateRoute adminOnly>
              <DashboardLayout>
                <TenantDetail />
              </DashboardLayout>
            </PrivateRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
